import { default as MuiAccordionDetails } from '@mui/material/AccordionDetails';

/**
 * AccordionDetails contains the collapsible content of an Accordion item.
 *
 * Demos:
 *
 * - [Accordion — Details](https://unify.workiva.org/components/accordion?tab=code)
 *
 * API:
 *
 * - [AccordionDetails API](https://unify.workiva.org/components/accordion?tab=props#accordiondetails)
 */
export const AccordionDetails = MuiAccordionDetails;
export {
  type AccordionDetailsProps,
  accordionDetailsClasses,
} from '@mui/material/AccordionDetails';
